// import "@snpjs/crystalbridge/lib/css/snpkit-crystalbridge.css";
import React, { useState, useEffect } from "react";
import { BreadcrumbsProvider } from "../../breadcrumbs/breadcrumbsProvider/BreadcrumbsProvider";
import { ConfigContextProvider } from "../../configContextProvider/ConfigContextProvider";
import { Footer } from "../../../features/footer/Footer";
import { Header } from "../../../features/header/Header";
import { AnnouncementBanner } from "../../../components/announcement/AnnouncementBanner";
import { IPageProps } from "./IPageProps";
import { PageInfo } from "../pageInfo/PageInfo";
import { Search } from "../../search/Search";
import { style } from "../../../utils/style";
import styles from "./Page.module.scss";

/**
 * This is an abstract page, that is the base for each other concrete page.
 * It provides a general structure of a page like defining header or footer.
 */
export const Page: React.FC<IPageProps> = (props) => {
  const [isPageInfoOpen, setIsPageInfoOpen] = useState(true);
  const showAnnouncement = props.showAnnouncement ?? true;

  useEffect(() => {
    setIsPageInfoOpen(false);
  }, []);

  const togglePageInfo = () => {
    setIsPageInfoOpen((prev) => !prev);
  };

  const toggleSearchBar = () => {
    if (!props.infoArea) {
      return "1rem";
    }
    return isPageInfoOpen ? "4.1rem" : "22.8rem";
  };

  return (
    <ConfigContextProvider>
      <Header />
      <div className={styles.content}>
        <main className={styles.main}>
          <div className={styles.header}>
            <div className={styles.breadcrumbRow}>
              {props.showBreadcrumbs && <BreadcrumbsProvider />}
            </div>
            {showAnnouncement && (
              <div className={styles.bannerRow}>
                <AnnouncementBanner />
              </div>
            )}
            {props.search && (
              <div
                // className={styles.search}
                style={{ marginRight: toggleSearchBar() }}
              >
                <Search {...props.search} />
              </div>
            )}
          </div>
          <div className={style(styles.pageContent, props.className)}>
            {props.children}
          </div>
          <div className={styles.pageInfo} onClick={togglePageInfo}>
            {(props.showPageInfo === undefined ||
              props.showPageInfo === true) && 
              props.infoArea && (
              <div className={styles.infoArea}>
                <PageInfo
                  iconName={props.iconName ?? "snp"}
                  infoArea={props.infoArea}
                  isPageInfoOpen={isPageInfoOpen}
                  onTogglePageInfo={togglePageInfo}
                />
              </div>
            )}
          </div>
        </main>
        <Footer />
      </div>
    </ConfigContextProvider>
  );
};
